/* All spinners use Tailwind animate-spin / animate-bounce — no custom CSS dependency */

/* ── Inline spinner inside buttons ── */
export function SpinnerInline() {
  return (
    <span
      className="inline-block w-4 h-4 rounded-full animate-spin flex-shrink-0"
      style={{ border: "2px solid rgba(255,255,255,0.3)", borderTopColor: "white" }}
    />
  );
}

/* ── Full page / section loader ── */
export function PageLoader({ message = "Loading..." }) {
  return (
    <div className="flex flex-col items-center justify-center py-24 gap-6">
      {/* Spinner ring */}
      <div className="relative w-16 h-16">
        {/* track */}
        <div
          className="absolute inset-0 rounded-full"
          style={{ border: "3px solid rgb(var(--border))" }}
        />
        {/* spinning arc */}
        <div
          className="absolute inset-0 rounded-full animate-spin"
          style={{
            border: "3px solid transparent",
            borderTopColor: "rgb(var(--primary))",
            borderRightColor: "rgb(var(--primary))",
          }}
        />
        {/* center dot pulse */}
        <div
          className="absolute inset-0 m-auto w-3 h-3 rounded-full animate-pulse"
          style={{ background: "rgb(var(--primary))", opacity: 0.5 }}
        />
      </div>

      {/* Label + bouncing dots */}
      <div className="flex flex-col items-center gap-2">
        <p className="text-sm font-semibold tracking-wide" style={{ color: "rgb(var(--primary))" }}>
          {message}
        </p>
        <div className="flex gap-1.5">
          {[0, 1, 2].map((i) => (
            <span
              key={i}
              className="w-1.5 h-1.5 rounded-full animate-bounce"
              style={{
                background: "rgb(var(--primary))",
                opacity: 0.5,
                animationDelay: `${i * 0.18}s`,
              }}
            />
          ))}
        </div>
      </div>
    </div>
  );
}

/* ── Table row loader ── */
export function TableSpinner({ cols }) {
  return (
    <tr>
      <td colSpan={cols}>
        <div className="flex flex-col items-center justify-center py-20 gap-5">
          <div className="relative w-14 h-14">
            <div
              className="absolute inset-0 rounded-full"
              style={{ border: "3px solid rgb(var(--border))" }}
            />
            <div
              className="absolute inset-0 rounded-full animate-spin"
              style={{
                border: "3px solid transparent",
                borderTopColor: "rgb(var(--primary))",
                borderRightColor: "rgb(var(--primary))",
              }}
            />
          </div>
          <div className="flex flex-col items-center gap-2">
            <p className="text-xs font-semibold uppercase tracking-widest" style={{ color: "rgb(var(--primary))", opacity: 0.6 }}>
              Loading...
            </p>
            <div className="flex gap-1">
              {[0, 1, 2].map((i) => (
                <span
                  key={i}
                  className="w-1.5 h-1.5 rounded-full animate-bounce"
                  style={{ background: "rgb(var(--primary))", opacity: 0.4, animationDelay: `${i * 0.18}s` }}
                />
              ))}
            </div>
          </div>
        </div>
      </td>
    </tr>
  );
}
